/**
 * The range the statistics request actually asks for.
 *
 * The picker hands back a range whose end is normalized to the start of the chosen day, so sending
 * it unchanged asks for nothing on that day but midnight: pick "15 September to 1 October" and every
 * booking on 1 October is silently missing. The sector reservation lists widen it before querying
 * (WeeklyPlannerReservationList does `startOfDay(start)` and `endOfDay(end)`), and these figures have
 * to agree with those lists row for row, so they widen it the same way.
 */
import {endOfDay, startOfDay} from "crqlar-react-common/dist/utils/date.util";
import type {DateRange} from "../../common/newDatePicker/datePickerShared";

export const statisticsRange = (range: DateRange): DateRange => ({
    start: startOfDay(range.start),
    end: endOfDay(range.end),
});
